import React, {ReactNode} from 'react';
import './styles';

import confettiAnimation from '@assets/animations/Confetti.json';
import Box from '@mui/material/Box';
import Lottie from 'lottie-react';

import useWindowSize from '@/hooks/WindowSize/WindowSize';

import {AppButton} from '../AppButton';
import {ButtonContainer} from '../ButtonContainer';
import ProgressBar from '../ProgressBar/ProgressBar';

type ResultScreenProps = {
  imgSrc?: string;
  title?: ReactNode;
  description?: ReactNode;
  buttonText?: string;
  progressBarDuration?: number;
  showConfetti?: boolean;
  bottomContent?: ReactNode;
  onDurationEnds?: () => void;
  onButtonClick?: () => void;
};

const ResultScreen: React.FC<ResultScreenProps> = ({
  imgSrc,
  title,
  description,
  buttonText,
  progressBarDuration,
  showConfetti = false,
  bottomContent,
  onDurationEnds,
  onButtonClick,
}) => {
  const {isMobile} = useWindowSize();
  return (
    <Box
      className="result-screen-container"
      style={{paddingBlock: isMobile ? '35%' : ''}}>
      {showConfetti && (
        <Lottie
          animationData={confettiAnimation}
          className="confetti"
          loop={false}
        />
      )}
      <Box className="result-screen">
        {imgSrc && (
          <img
            src={imgSrc}
            alt="Result"
            width="120"
            height="120"
          />
        )}
        {title && title}
        {description && description}
      </Box>

      {!buttonText ? (
        progressBarDuration && (
          <Box className="progress-bar-container">
            <ProgressBar
              value={0}
              onDurationEnds={onDurationEnds}
              duration={progressBarDuration}
            />
          </Box>
        )
      ) : (
        <ButtonContainer sticky>
          <AppButton
            id="result-screen-button"
            onClick={onButtonClick}
            label={buttonText}
          />
        </ButtonContainer>
      )}

      {bottomContent && bottomContent}
    </Box>
  );
};

export default ResultScreen;
